import styled, { keyframes } from 'styled-components';
import { Box } from '../Box/Box';

export const pulse = keyframes`
  from {
    opacity: 0.8;
  }
  to {
    opacity: 0.3;
  }
`;

interface ShimmerProps {
  isRound?: boolean;
}

export const Shimmer = styled(Box)<ShimmerProps>`
  background: ${props => props.theme.colors.neutral[200]};
  animation: ${pulse} 1s infinite alternate;
  border-radius: ${({ isRound }) => (isRound ? '999px' : '6px')};
`;
